import { Box, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import AppCard from './AppCard';
import { MYAPPS_ITEMS_COUNT_ROW } from '../../../common/constants';

class AppsPanel extends Component {
  state = {};

  render() {
    return (
      <React.Fragment>
        <Box className="appsPanel">
          <Grid
            container
            justifyContent={'space-between'}
            direction={'column'}
            alignItems={'center'}
            gap={1}
            xs={12}
            style={{ height: '100%' }}
          >
            <Grid
              item
              container
              xs={2}
              width={'100%'}
              padding={1}
              justifyContent={'flex-start'}
              alignItems={'flex-start'}
            >
              {this.props.apps.map((app) => {
                return (
                  <Grid item className="p-0" xs={12 / MYAPPS_ITEMS_COUNT_ROW} key={app.id}>
                    <AppCard
                      className="sortableApp"
                      app={app}
                      moveApp={this.props.moveApp}
                      getSideAppsIndexes={this.props.getSideAppsIndexes}
                    />
                  </Grid>
                );
              })}
            </Grid>

            <Grid item>
              <Typography
                variant="h6"
                sx={{ wordBreak: 'break-word', width: '100%' }}
                className="appCardTitle"
              >
                Panel {this.props.panelNo}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </React.Fragment>
    );
  }
}

export default AppsPanel;
